import classNames from 'classnames';
import React from 'react';
import type { OptionTypeBase } from 'react-select';
import ClearIndicator from './components/select-clear';
import Control from './components/select-control';
import DropdownIndicator from './components/select-drop-icon';
import LoadingIndicator from './components/select-loading';
import MultiValueRemove from './components/select-multi-remove';
import Option from './components/select-option';
import { useSelectStyling } from './select.styled';
import { AbstractSelectProps } from './select.types';
import { noOptionsMessage as nom, loadingMessage as lom } from './select.utils';

const AbstractSelect = <
  OptionType extends OptionTypeBase = { label: React.ReactNode; value: any },
  IsMulti extends boolean = false,
>(
  props: AbstractSelectProps<OptionType, IsMulti>,
  ref?: React.Ref<any>,
) => {
  const {
    left,
    outlined = false,
    error,
    clearable,
    styles,
    className,
    disabled,
    isDisabled,
    components,
    Component,
    noOptionsMessage,
    loadingMessage,
    ...rest
  } = props;
  const styling = useSelectStyling({
    hasLeft: !!left,
    outlined,
    error,
    overrideStyles: styles as any,
  });

  return (
    // @ts-expect-error
    <Component
      ref={ref}
      {...rest}
      className={classNames('ui-select', className)}
      classNamePrefix="ui-react-select"
      styles={styling}
      components={{
        Control,
        ClearIndicator,
        DropdownIndicator,
        MultiValueRemove,
        LoadingIndicator,
        Option,
        ...components,
      }}
      left={left}
      isClearable={props.isClearable ?? clearable}
      isMulti={'isMulti' in props ? props.isMulti : false}
      closeMenuOnSelect={props.closeMenuOnSelect ?? !props.isMulti}
      hideSelectedOptions={props.hideSelectedOptions ?? false}
      placeholder={props.placeholder ?? ''}
      isDisabled={disabled || isDisabled}
      noOptionsMessage={noOptionsMessage ?? nom}
      loadingMessage={loadingMessage ?? lom}
    />
  );
};

export default React.forwardRef(AbstractSelect) as typeof AbstractSelect;
